import React from 'react';
import { Plus, ChevronLeft, ChevronRight } from 'lucide-react';
import { EventFilter } from './EventFilter.tsx';

interface CalendarHeaderProps {
  selectedFilter: 'all' | 'tasks' | 'events';
  onFilterChange: (filter: 'all' | 'tasks' | 'events') => void;
  onAddEvent: () => void;
  onYearChange: (direction: 1 | -1) => void;
  onMonthChange: (direction: 1 | -1) => void;
  selectedYear: number;
  isMonthView: boolean;
}

export const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  selectedFilter,
  onFilterChange,
  onAddEvent,
  onYearChange,
  onMonthChange,
  isMonthView,
}) => {
  const handleNavigationClick = (direction: 1 | -1) => {
    if (isMonthView) {
      onMonthChange(direction);
    } else {
      onYearChange(direction);
    }
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-3 lg:gap-4">
          <EventFilter selectedFilter={selectedFilter} onFilterChange={onFilterChange} />
          <button
            onClick={onAddEvent}
            className="flex items-center px-4 lg:px-6 py-2.5 lg:py-3 text-sm lg:text-base 
              bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg
              shadow-sm hover:shadow-md transition-all duration-200"
          >
            <Plus className="w-4 h-4 lg:w-5 lg:h-5 mr-2" />
            Add Event
          </button>
        </div>
        
        <div className="flex items-center gap-2 lg:gap-3">
          <button
            onClick={() => handleNavigationClick(-1)}
            className="p-2.5 lg:p-3 rounded-lg 
              bg-white hover:bg-gray-50 border border-gray-200
              text-gray-600 hover:text-gray-900 shadow-sm hover:shadow-md
              transition-all duration-200"
          >
            <ChevronLeft className="w-4 h-4 lg:w-5 lg:h-5" />
          </button>
          <button
            onClick={() => handleNavigationClick(1)}
            className="p-2.5 lg:p-3 rounded-lg 
              bg-white hover:bg-gray-50 border border-gray-200
              text-gray-600 hover:text-gray-900 shadow-sm hover:shadow-md
              transition-all duration-200"
          >
            <ChevronRight className="w-4 h-4 lg:w-5 lg:h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};